import React from 'react';

/**
 * Bottom bar with "Calcular Orçamento" CTA.
 * Enabled only when all rooms have acabamentos defined.
 */
export default function BottomBar({ rooms, onCalcular }) {
  const total = rooms.length;
  const completed = rooms.filter(r => r.ok).length;
  const allDone = total > 0 && completed === total;

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '10px 16px',
      borderTop: '1px solid #E5E7EB',
      background: '#FFFFFF',
    }}>
      <div style={{
        fontSize: 12,
        color: '#6B7280',
        fontFamily: 'Inter, sans-serif',
      }}>
        {allDone
          ? '✅ Todos os acabamentos definidos — pronto para calcular!'
          : `Defina acabamentos para todos os cômodos (${completed}/${total})`
        }
      </div>

      <button
        onClick={onCalcular}
        disabled={!allDone}
        style={{
          padding: '10px 24px',
          background: allDone ? '#F97316' : '#D1D5DB',
          color: allDone ? '#FFFFFF' : '#9CA3AF',
          border: 'none',
          borderRadius: 8,
          fontWeight: 700,
          fontSize: 14,
          fontFamily: 'Inter, sans-serif',
          cursor: allDone ? 'pointer' : 'not-allowed',
          transition: 'all 0.2s',
          boxShadow: allDone ? '0 2px 8px rgba(249,115,22,0.3)' : 'none',
        }}
      >
        Calcular Orçamento
      </button>
    </div>
  );
}
